<div class="background">
    <div class="content">
        <div class="custom-card">
            <div class="custom-card-header">
                <div class="title float-start">
                    LOGIN
                </div>
                <div class="float-end logo">
                    <img src="../../../../assets/images/Moodys-logo.svg"/>
                </div>
            </div>
        </div>
    </div>
</div>
